// src/pages/Gallery.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useAuth } from '../AuthProvider';
import '../styles/LittleChiefStyle.css';

const Gallery = () => {
    const [mediaItems, setMediaItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();

    useEffect(() => {
        const fetchMedia = async () => {
            try {
                // ← point at the same collection your uploader uses
                const mediaCollection = collection(db, 'media');
                const snap = await getDocs(mediaCollection);
                const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                setMediaItems(items);
            } catch (err) {
                console.error('Error fetching media:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchMedia();
    }, []);

    const handleDelete = async id => {
        if (!window.confirm('Delete this media?')) return;
        try {
            // ← delete from "media" too
            await deleteDoc(doc(db, 'media', id));
            setMediaItems(cur => cur.filter(item => item.id !== id));
        } catch (err) {
            console.error('Error deleting media:', err);
        }
    };

    if (loading) return <p>Loading gallery...</p>;

    return (

        <div className="outer-gallery-container">
            <h1>Luke Little Chief Gallery</h1>
        <div className="gallery-container">
            {mediaItems.length > 0 ? (
                mediaItems.map(item => (
                    <div key={item.id} className="gallery-item">
                        {/* use the same field names your uploader wrote */}
                        {item.mediaType === 'image' && <img src={item.url} alt={item.name} className="gallery-image" />}
                        {item.mediaType === 'video' && (
                            <video controls src={item.url} className="gallery-video" />
                        )}
                        {item.mediaType === 'embed' && (
                            <div className="embed-wrapper">
                                <iframe
                                    src={item.url}
                                    title={item.name}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                        )}

                        {/* show title & description */}
                        <h3>{item.name}</h3>
                        <p>{item.description}</p>

                        {/* only show delete if it’s yours */}
                        {user && item.ownerId === user.uid && (
                            <button
                                onClick={() => handleDelete(item.id)}
                                className="gallery-delete-button"
                            >
                                Delete
                            </button>
                        )}
                    </div>
                ))
            ) : (
                <p>No media items in the gallery yet.</p>
            )}
        </div>
        </div>
    );
};

export default Gallery;
